// Copyright (c) Ensho Health, 2021 to present

import styled from 'styled-components';
import { InputGroup, Button, Colors } from '@blueprintjs/core';
import { ENSHO_COLORS } from '../../constants';

export const StyledForm = styled.form`
  width: 450px;
  margin-left: auto;
  margin-right: auto;
`;

export const StyledLink = styled.div`
  cursor: pointer;
  margin-top: 30px;
  padding-left: 2px;
  text-align: center;
  text-decoration: none;
  font-size: 14px;
  color: ${ENSHO_COLORS.BLUE.LINK};
  & a {
    color: ${ENSHO_COLORS.BLUE.LINK};
  }
`;

export const StyledSubmitButton = styled(Button)`
  margin-top: 30px;
  width: 100%;
  height: 40px;
  color: ${Colors.WHITE};
  background-color: ${Colors.BLACK};
  &:disabled: {
    background-color: ${ENSHO_COLORS.GRAY.DISABLED};
  }
`;

export const StyledEnshoButton = styled(Button)`
  margin-top: 30px;
  background-color: ${ENSHO_COLORS.GREEN.BUTTON};
  padding: 0;
  color: ${Colors.BLACK};
  font-size: 10pt;
  height: 35px;
  border-radius: 3px;
  width: 100%;
`;

export const StyledError = styled.p`
  color: ${ENSHO_COLORS.RED.ERROR};
  margin-top: 30px;
  text-align: center;
`;

export const StyledInput = styled(InputGroup)`
  margin-top: 30px;
`;

export const StyledInstructions = styled.div`
  margin-top: 30px;
  margin-bottom: 20px;
  font-size: 18px;
  & ul {
    list-style-position: inside;
    list-style-type: '  - ';
  }
`;
